export { default } from "./Hero";
